import { useEffect, useMemo, useState } from 'react'
import { Modal } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

import { wireBlotterInputs } from './constants'
import { type IWireBlotterRow, emptyWireBlotterRow } from './types'

export const EditWireBlotterDialog = ({
  item,
  loanOptions,
  onClose,
  onSave,
}: {
  item: Partial<IWireBlotterRow> | null
  loanOptions: Record<string, string>
  onClose: () => void
  onSave: (data: Partial<IWireBlotterRow>) => Promise<void>
}) => {
  const [form, setForm] = useState<Partial<IWireBlotterRow>>(emptyWireBlotterRow())
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!item) return
    setForm({
      ...item,
      wireDate: item.wireDate ? String(item.wireDate).slice(0, 10) : '',
    })
  }, [item])

  const inputs = useMemo(() => wireBlotterInputs(form, loanOptions), [form, loanOptions])

  if (!item) return null

  const onChange = (key: string, value: any) => {
    setForm((prev) => ({ ...prev, [key]: value }))
  }

  const onSubmit = async () => {
    setSaving(true)
    try {
      await onSave({
        wireDate: form.wireDate || null,
        direction: form.direction,
        counterparty: form.counterparty,
        loanId: form.loanId,
        amount: Number(form.amount || 0),
        purpose: form.purpose,
      })
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      isOpen
      title={item.id ? 'Edit Wire' : 'Add Wire'}
      loading={saving}
      disabled={Number(form.amount || 0) <= 0}
      onOk={onSubmit}
      onClose={onClose}
      titleOkay="Save"
      titleCancel=""
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
        {Object.keys(inputs).map((key) => (
          <RenderInput key={key} input={inputs[key]} Key={key} onChange={onChange} />
        ))}
      </div>
    </Modal>
  )
}
